import { render } from "./Legislacao.vue?vue&type=template&id=7e864b85&scoped=true"
import script from "./Legislacao.vue?vue&type=script&lang=js"
export * from "./Legislacao.vue?vue&type=script&lang=js"

import "./Legislacao.vue?vue&type=style&index=0&id=7e864b85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e864b85"]])

export default __exports__